<template>
  <el-select ref="remoteSelectRef" clearable filterable remote reserve-keyword remote-show-suffix v-bind="$attrs" v-model="selectValue" :placeholder="getPlaceholder()" :remote-method="remoteMethod" :loading="loading" @change="selectChange" @visible-change="hidden" @blur="handleBlur" @clear="clearMethod">
    <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
    <div>
      <el-pagination
          small
          layout="prev, pager, next, total"
          @current-change="handlePageChange"
          :current-page="query.page"
          :page-size="query.limit"
          :total="count">
      </el-pagination>
    </div>
  </el-select>
</template>

<script>
export default {
  name: "YmSearchSelect"
}
</script>
<script setup>
import {ElSelect,ElOption,ElPagination} from "element-plus";
import 'element-plus/dist/index.css'
import {reactive, ref, defineProps, useAttrs, onMounted, defineEmits,defineExpose, watch} from "vue";
import { debounce,isEmpty} from 'lodash-es';
const emits = defineEmits(["update:modelValue", 'dochange']);
const props = defineProps({
  api: { // 接口类型
    required: true,
    type: [Function]
  },
  placeholder: {
    type: String,
    default: ''
  },
  selectList: {
    //回显默认值
    type: Array
  },
  callback: {
    type: Function,
    default:  function(query,res){  return res?.data?.list }
  },
  modelValue: {
    type: [Number, String],
    default: ''
  }
})
const attr = useAttrs()
const selectValueDeal = () => {
  return attr?.multiple ? (props.modelValue ? props.modelValue.split(',') : []) : props.modelValue + ''
}
// 初始化下拉组件
const remoteSelectRef = ref()
const selectInit = ref(true)
const selectValue = ref(selectValueDeal())
const list = ref([])
const options = ref([])
const loading = ref(false)
const is_select = ref(false)
const is_blur = ref(false)
const count = ref(0)
const query = reactive({
  search:'',
  page: 1,
  limit: 10,
})
const getPlaceholder = () => {
  return '搜索选择' + (props.placeholder || props.api(query))
}

const getDataDeal = (res) => {
  let option = props.api(query,'option')
  let callback = props.api(query,'callback')
  res.then(res => {
    list.value = typeof callback === 'function' ? callback(res) : (typeof props.callback === 'function' ? props.callback(query,res) : res.data.list)
    if(!res.data.list || res.data.list.length == 0){
      selectInit.value = true
    }else{
      selectInit.value = false
    }
    let opt = [];
    res.data.list.forEach((item) => {
      opt.push({ label: typeof option === 'function' ? option(item) : item[option], value: item.id + '' });
    });
    options.value = opt
    count.value = res.data.count
    query.limit = res.data.limit || query.limit
  }).finally(() => {
    loading.value = false
  })
}
//debounce 防抖 点击多次之后的最后一次才会请求
const getData = debounce(() => {
  loading.value = true;
  getDataDeal(props.api(query,'req'))
}, 400)
//初始化触发
onMounted(() => {
  selectInit.value = true
})

watch(() => props.modelValue, (newValue, oldVal) => {
  if (!(is_select.value) && (newValue || newValue == 0)) {
    selectValue.value = selectValueDeal()
  }
}, { immediate: true, deep: true })
watch(() => props.selectList, (newValue, oldVal) => {
  if(!isEmpty(newValue) && typeof newValue != 'string'){
    let option = props.api(query,'option')
    list.value = newValue
    let opt = [];
    newValue.forEach((item) => {
      opt.push({ label: typeof option === 'function' ? option(item) : item[option], value: item.id + '' });
    });
    options.value = opt
    loading.value = false
  }
}, { immediate: true, deep: true })

const remoteMethod = (keyword) => {
  query.search = keyword
  if(!selectValue.value){
    query.page = 1
  }
  getData();
}

const selectChange = (val) => {
  is_select.value = true
  let update_val = attr?.multiple ? val.join(',') : val
  is_blur.value = false
  emits("update:modelValue", update_val)
  let select_list = [];
  for (let i in list.value) {
    let item = list.value[i]
    if (val.includes(item.id)) {
      select_list.push(item)
    }
  }
  emits('dochange', select_list)
}

const handlePageChange = (val) => {
  query.page = val;
  getData();
}

const clearMethod = () => {
  query.page = 1
}

const handleBlur = () => {
  if (!attr?.multiple) is_blur.value = true
}
const hidden = (bool) => {
  if (!bool) {
    // 关闭select下拉框的时候重置页码及数据,并移除事件监听
    // 移除mousedown事件监听
    removeEventListener("mousedown", function () { }, false);
  } else {
    // 打开select列表
    // 增加mousedown事件监听  当点击分页时移除输入框的默认事件 ，让他不会失去焦点（blur),如果不加，就会
    // 出现当用户点击分页之后，输入框会失去焦点，这个时候如果用户需要输入数据进行搜索就需要先删除输入框的值再输入，体验不好。
    // （elementUI下拉框的默认样式，当可搜索时点击输入框可直接输入，不需要删除上次数据）
    document.addEventListener(
        "mousedown",
        function (e) {
          if (
              e.target.tagName === "LI" ||
              (e.target.tagName == "I" && e.target.localName == "i")
          ) {
            e.preventDefault();
          }
        },
        false
    );
    //初始化处理
    if(selectInit.value){
      query.search = ''
      if(!isEmpty(props.selectList)) options.value = []
      getData();
    }
  }
}
// 重置
const handleReset = ()=>{
  is_blur.value = true
  query.page = 1
  options.value = []
  selectValue.value = ''
  selectInit.value = true
  emits("update:modelValue", '')
  emits('dochange', [])
}
defineExpose({handleReset})
</script>

<style scoped>
.el-select{
  width:100%;
}
</style>
